import { SELECT_ANSWER } from './actionTypes'

const init = {
  answers: [],
}

export default (state = init, action) => {
  switch (action.type) {
    case SELECT_ANSWER:
      let update = false
      // check if question was answered already
      const updatedAnswers = state.answers.map(ans => {
        if (ans.question === action.payload.question) {
          update = true
          return {
            ...ans,
            answer: action.payload.answer,
            answerLetter: action.payload.answerLetter,
          }
        }
        return ans
      })

      // if no updates are made, add the new answer
      if (!update) {
        return {
          ...state,
          answers: [...state.answers, action.payload],
        }
      }
      // else, swap in the updated answers
      return {
        ...state,
        answers: updatedAnswers,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./js/components/answersReducer.js